<template>
    <section class="opui-section">
        <div class="opui-top-menu opui-d-flex opui-justify-content-between opui-align-items-center opui-mb-0">
            <ul class="opui-pl-5">
                <li class="opui-d-flex opui-align-items-center">
                    <router-link to="/" class="opui-logo">
                        <i class="opui-icon-logo"></i>
                    </router-link>
                </li>
            </ul>

            <nav class="opui-main-menu">
                <input class="opui-hamburger-input" type="checkbox" />
                <div class="opui-hamburger-menu">
                    <span class="opui-hamburger-bar"></span>
                    <span class="opui-hamburger-bar"></span>
                    <span class="opui-hamburger-bar"></span>
                </div>

                <ul class="opui-right-menu">
                    <li>
                        <a :href="adminUrl('admin.php?page=op-suite')">
                            <i class="opui-icon opui-icon-dashboard-complex"></i>
                            <span>{{ $e('Dashboard') }}</span>
                        </a>
                    </li>
                    <li>
                        <router-link to="/">
                            <i class="ops-iconFont ops-layers-icon"></i>
                            <span>{{ $e('Create New Page') }}</span>
                        </router-link>
                    </li>
                    <!-- <li>
                        <a href="https://marketplace.optimizepress.com/" target="_blank">
                            <i class="ops-iconFont ops-shopping-cart-icon"></i>
                            <span>{{ $e('Marketplace') }}</span>
                        </a>
                    </li> -->
                    <li>
                        <a :href="adminUrl('admin.php?page=op-dashboard-integrations')">
                            <i class="ops-iconFont ops-integrations-round-icon"></i>
                            <span>{{ $e('Integrations') }}</span>
                        </a>
                    </li>
                    <li>
                        <a :href="adminUrl('admin.php?page=op-dashboard-settings')">
                            <i class="opui-icon-settings-square"></i>
                            <span>{{ $e('Tracking') }}</span>
                        </a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="toggleSubmenu">
                            <i class="opui-icon-logo"></i>
                            <span>{{ $e('Tools') }}</span>
                        </a>

                        <ul class="opui-submenu" :class="{ 'opui-d-block': showSubmenu }">
                            <li v-for="tool in tools">
                                <a :href="tool.url" :title="tool.title"
                                    ><span>{{ tool.title }}</span></a
                                >
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="https://optimizelink.com/flow" target="_blank">
                            <i class="opui-icon-help"></i>
                            <span>{{ $e('Help') }}</span>
                        </a>
                    </li>
                    <li class="opui-fullscreen-btn">
                        <a @click.prevent="toggleFullscreenApp" href="#">
                            <i class="opui-icon-fullscreen-fill"></i>
                            <span>{{ $e('Fullscreen') }}</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </section>
    <header>
        <div class="opui-submenu opui-d-flex opui-justify-content-between opui-align-items-center opui-pl-5 opui-pr-5">
            <div>
                <slot name="title">
                    <h1>{{ $e('Create new page') }}</h1>
                </slot>
            </div>

            <div v-if="settingsStore.slLicenseIsValid !== null">
                <div v-if="!settingsStore.slLicenseIsValid">
                    <!-- <a class="opui-btn opui-btn-danger" href="https://my.optimizepress.com/account/reactivate" target="_blank">
                        {{ $e('Reactivate license') }}
                    </a> -->
                </div>
                <div v-else>
                    <slot name="right-menu-buttons">
                        <a href="#" @click.prevent="openQuickstart" class="opui-btn opui-btn-outline">Watch Quickstart Guide</a>
                    </slot>
                </div>
            </div>
        </div>
    </header>

    <Reactivate v-if="!settingsStore.slLicenseIsValid" />

    <BuilderDisabled v-if="!settingsStore.builderEnabled" />
</template>

<script>
import BuilderDisabled from './BuilderDisabled.vue'
import Quickstart from './Quickstart.vue'
import Reactivate from './Reactivate.vue'
import { useSettingsStore } from '../../store/settings'
import { mapStores } from 'pinia'
import { toggleFullscreen } from 'optimizepress-ui/src/js/fullscreen'

export default {
    components: { BuilderDisabled, Quickstart, Reactivate },
    computed: {
        ...mapStores(useSettingsStore),
    },
    data() {
        return {
            tools: window.OptimizeTemplates.tools,
            showSubmenu: false,
        }
    },
    created() {
        // console.log(this.settingsStore.opfw);
        if (!window.localStorage.getItem('OPTemplatesVideoWasWatched')) {
            this.openQuickstart()
        }
    },
    methods: {
        /**
         * We are adding class to body and triggering AJAX action from OP Dashboard 'op3toggleFullScreen'
         */
        toggleFullscreenApp() {
            toggleFullscreen()
        },

        /**
         * Toggle the tools submenu
         */
        toggleSubmenu() {
            this.showSubmenu = !this.showSubmenu
        },

        openQuickstart() {
            this.$vfm.show({
                component: Quickstart,
                on: {
                    closed: () => {
                        window.localStorage.setItem('OPTemplatesVideoWasWatched', true)
                    },
                },
            })
        },
    },
}
</script>

<style scoped>
.opui-btn-outline {
    color: rgb(113, 123, 132) !important;
    border-color: rgb(209, 213, 219) !important;
}
</style>
